module.exports = __webpack_public_path__ + "static/media/Roxx-Racing-Logo.a7d76f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Roxx-Racing-Logo.png
// module id = 102
// module chunks = 0